var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUeberhoehungMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Ueberhoehung_Minus__Icn/40px/Ueberhoehung_Minus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Ueberhoehung_Minus__Color/20px/Platzhalter-Transparent",
    transform: "translate(10 10)",
    fillRule: "nonzero",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Icn_40px_Ueberhoehung_Minus__Rectangle",
    d: "M0 0H20V20H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12,17 C16.9705627,17 21,21.0294373 21,26 C21,30.9705627 16.9705627,35 12,35 C7.02943725,35 3,30.9705627 3,26 C3,21.0294373 7.02943725,17 12,17 Z M12,19 C8.13400675,19 5,22.1340068 5,26 C5,29.8659932 8.13400675,33 12,33 C15.8659932,33 19,29.8659932 19,26 C19,22.1340068 15.8659932,19 12,19 Z M17,25 L17,27 L7,27 L7,25 L17,25 Z M26.357066,3.11744336 L37.5029869,22 L23.8197037,21.9994434 L23.8197037,19.9994434 L34,20 L26.3264114,7 L21.8347037,14.3424434 L23.7845502,16.8095612 L22.2154498,18.0496917 L20.6607037,16.0824434 L17.8989473,12.6799044 L15.7497037,15.3464434 L14.2907037,13.9684434 L17.893444,9.49933865 L20.492,12.702 L26.357066,3.11744336 Z",
    id: ".._.._src_svg_Icn_40px_Ueberhoehung_Minus__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUeberhoehungMinus);
export default __webpack_public_path__ + "static/media/Ueberhoehung_Minus.ad0f7e9ceca0884c5dec70856c3a25fc.svg";
export { ForwardRef as ReactComponent };